import DeviceManagement from "./DeviceManagement.vue";

export default {
  path: "/config/device-management",
  name: "DeviceManagement",
  component: DeviceManagement,
  meta: {
    breadcrumb: "deviceManagement"
  }
};
